import { currentTzMillis, getNotifyTime } from './steps/utils';
import * as yup from 'yup';
import {
  Notification,
  NotificationDetails,
  NotificationType,
} from '@ssar-app/domain';

export const notificationPublishStepValidator = yup.object<NotificationDetails>(
  {
    startTime: yup
      .number()
      .required('Enter valid Start Date & Time')
      .test(
        'startTimeValidation',
        `Start Time should be greater than Current Time`,
        function (value) {
          const timeZone = this.parent.timeZone;
          return value >= currentTzMillis(timeZone);
        },
      ),
    endTime: yup
      .number()
      .required('Eenter valid End Date & Time')
      .test(
        'endTimeValidation',
        'End Time should be greater than Start Time',
        function (value) {
          return !this.parent.startTime || value > this.parent.startTime;
        },
      ),
    duration: yup
      .number()
      .required()
      .test(
        'durationValidation',
        `Enter valid Number of hours/days`,
        function (value) {
          if (value === -1) {
            return true;
          }
          return (
            !this.parent.startTime ||
            value === 0 ||
            (getNotifyTime(this.parent) <= this.parent.startTime &&
              getNotifyTime(this.parent) >=
                currentTzMillis(this.parent.timeZone))
          );
        },
      ),
    timeZone: yup.string().required(),
    unitOfTime: yup.number().min(0).required(),
  },
);

const titleValidator = yup.string().nullable().required();
const descriptionValidator = yup
  .string()
  .nullable()
  .required()
  .when('type', {
    is: NotificationType.MAINTENANCE,
    then: yup
      .string()
      .required()
      .test(
        'descValidation2',
        'Date display argument is missing.',
        function (value) {
          return value.indexOf('{0}') !== -1;
        },
      ),
  });

export const notificationBasicDetailsValidator = yup.object<
  Partial<Notification>
>({
  title: titleValidator.required(),
  description: descriptionValidator.required(),
});
